import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        Rural Studio is a design-build education program of Auburn University,
        which creates ‘real-world’ projects for architecture students to
        explore, develop, and realise. Design projects are self-managed and
        self-built by the students, providing new housing and community
        facilities to an underserved population in West Alabama, with excellent
        architectural and construction experience for the students.
      </p>
      <p>
        I visited and provided labour during the Spring build-up to the
        end-of-year celebrations in 2005, allowing me to visit many of the
        projects and the people that they had supported, as well as a small
        insight into a framework whereby the enthusiasm of architecture students
        has been channelled to create benefits for local community groups.
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/alabama-rural-studio.jsx